export default __webpack_public_path__ + "static/media/transpaletaparapasillo.3dd4d4d5.png";